import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ConfigurationItem from './ConfigurationItem';

import './Configuration.scss';

class Configuration extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
  };

  get classes() {
    const { className } = this.props;

    return classNames('ca-configuration', className);
  }

  render() {
    const { title, children, ...others } = this.props;

    return (
      <section
        {...others}
        className={classNames(
          this.classes,
          '_d-block _bg-white _py-5 _px-4 md:_px-5 _mb-8 _rounded-md _border _border-gray-200'
        )}
      >
        <h2 className="_text-black _tw-text-2xl _font-weight-bold _mt-0 _mr-0 _mb-3 _mb-md-5 _ml-0">
          {title}
        </h2>

        {children}
      </section>
    );
  }
}

Configuration.Item = ConfigurationItem;

export default Configuration;
